module.exports = __webpack_public_path__ + "img/cl.7ac11748.svg";